import React from 'react'
import {getColor} from './colorForScorePath'
import lodash from 'lodash'
import * as scoreHierarchy from "../../scoreHierarchy";
import {UncontrolledTooltip} from "reactstrap"
import {cssVar} from "../../../../components/cssInJs"

/** donut container that handles titles and animations for the score preview section */
export const ScoreDonutSection = ({
  title,
  footer,
  totalScore,
  totalScoreIsLoading,
  totalScoreIsEstimate,
  scoreItems,
  tooltip,
  showEstimateInfo,
  showOutOf100,
  style = {},
  className = "",
  ...props
}) => {
  const id = `scoreTooltip`;
  return <div
    className={`align-content-vertically ${className}`}
    style={{flex: 1, margin: '0 10px', ...style}} {...props}
    >
    <DonutSectionLabel>{title}</DonutSectionLabel>
    <UncontrolledTooltip placement="left" target={id} >{totalScoreIsLoading ? 'Loading ...' : tooltip}</UncontrolledTooltip>
    <ScoreWeightDonut
      id={id}
      style={{maxHeight: '150px', maxWidth: '150px', display: 'block', margin: '0 auto'}}
      totalScore={totalScore}
      totalScoreIsLoading={totalScoreIsLoading}
      totalScoreIsEstimate={totalScoreIsEstimate}
      showOutOf100={showOutOf100}
      scoreItems={scoreHierarchy.filterTopLevelCategories(scoreItems)}
    />
    <DonutSectionLabel>{footer}</DonutSectionLabel>
  </div>

}

const DonutSectionLabel = ({children, style={}, ...props}) => {
  return <span style={{
    display: 'inline-block', textAlign: 'center', minHeight: '20px', overflow: 'hidden', minWidth: '12px',
    ...style
  }} {...props}>{children}</span>
}

export var radius = 100 / (2 * Math.PI);
export var width = 42;
/**
 * component that renders an svg donut of the default score components.
 * Largely copied from react-svg-donut-chart because I needed to add text to inside of the donut
 * */
export const ScoreWeightDonut = ({
  totalScore,
  totalScoreIsLoading,
  totalScoreIsEstimate,
  showOutOf100,
  scoreItems, // {{scorePath: String, value: Number}}[]
  ...props
}) => {
  const sum = scoreItems.reduce((sum, x) => sum + x.value, 0)
  var percentAcc = 0
  return <svg viewBox={`0 0 ${width} ${width}`} {...props}>
    {
      scoreItems.map(({scorePath, value}, i) => {
        var percent = value / sum * 100;
        var strokeDasharray = percent + " " + (100 - percent);
        var strokeDashoffset = i === 0 ? 0 : 100 - percentAcc;
        percentAcc += percent;
        return <circle
          key={scorePath}
          cx={width / 2}
          cy={width / 2}
          r={radius}
          fill="none"
          stroke={getColor(scorePath)}
          strokeWidth={"9"}
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}></circle>
      })
    }
    <SvgInnerDonutScore
      score={totalScore}
      isLoading={totalScoreIsLoading}
      isEstimate={totalScoreIsEstimate}
      showOutOf100={showOutOf100}
    />
  </svg>
}


export const SvgInnerDonutScore = ({
  score,
  isLoading,
  isEstimate,
  showOutOf100
}) => {
  if (isLoading) {
    return <SvgLoadingDots />
  } else {
    let number = "" + Math.round(score * 100);
    let noScore = score === undefined;
    const bodyColor = cssVar('--body-color');
    const headingsFontFamily = cssVar('--headings-font-family');
    const headingsFontWeight = cssVar("--headings-font-weight");
    return <svg>
      {
        /** The score */
        noScore ? undefined : <text
          dx={width / 2}
          dy={showOutOf100 ? width * (15 / 32) : width * (19 / 32)}
          textAnchor="middle"
          fontFamily={headingsFontFamily}
          fill={bodyColor}
          fontWeight={headingsFontWeight}
          fontSize={showOutOf100 ? 8 : 11}
        >{number}</text>
      }
      { /** show a solid horizontal gray line (minus) through the middle of the donut hole if there's no score */
        !noScore ? undefined : <rect
          x={14}
          y={width / 2 - 1}
          width={width - (14 * 2)}
          height={2}
          fill={bodyColor}
        />
      }
      {/** A lot of markup for a gray asterisk in the upper right corner of the donut hole */
        !isEstimate || noScore ? undefined : <text
        dx={number.length === 1 ? "24.5" : "28.5"}
        dy="19"
        fill={bodyColor}
        fontWeight={headingsFontWeight}
        fontSize="4"
        fontFamily={headingsFontFamily}
      >*
      </text>}
      {
        (!showOutOf100 || noScore) ? undefined :
          <text
            dx={width / 2}
            dy={width * (19 / 32)}
            textAnchor="middle"
            fill={bodyColor}
            fontWeight={headingsFontWeight}
            fontSize="3.25"
          >OUT OF 100</text>
      }
    </svg>
  }

}

class SvgLoadingDots extends React.Component {

  componentDidMount() {
    this.timer = setInterval(this.updateActiveDot.bind(this), 200)
    this.setState({activeIndex: 0})
    this.size = 5
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }
  updateActiveDot() {
    this.setState({ activeIndex: (this.state.activeIndex + 1) % this.size })
  }
  render () {
    const activeIndex = this.state && this.state.activeIndex;
    const bodyColor = cssVar('--body-color');
    return <svg>{
      lodash.range(0, this.size).map((x) => {
        let isActive = activeIndex === x;
        let offset = ((this.size + 1) / 2) - (x + 1);
        let cx = 21 + (offset * -4);
        let width = isActive ? 1.5 : 0.75;
        return <rect
          key={x}
          y={21 - width / 2}
          x={cx - width / 2}
          width={width}
          height={width}
          fill={bodyColor} />
      })
    }</svg>
  }
}
